import { Link } from "react-router";

import { EmptyState } from "../components/states";

export function NotFoundPage() {
  return (
    <div className="mx-auto max-w-xl py-10">
      <EmptyState
        title="Page not found"
        action={
          <Link to="/screen" className="text-sm text-sky-700 underline dark:text-sky-400">
            Go to Screen
          </Link>
        }
      >
        The address may be mistyped, or the page moved.
      </EmptyState>
    </div>
  );
}
